import CollapsibleSection from 'components/UI/Screen/CollapsibleSection';
import FeatureFlagDebugPanel from 'components/UI/FeatureFlagDebugPanel';
import Screen from 'components/UI/Screen';
import Footer from 'components/UI/Screen/Footer';
import Header from 'components/UI/Screen/Header';
import ListControlsBar from 'components/UI/Screen/ListControlsBar';
import NewCategoriesFilter from 'components/UI/Screen/NewCategoriesFilter';
import UserDetailsBar from 'components/UI/Screen/UserDetailsBar';
import { useBreakpoints } from 'hooks/useMediaQuery';
import { useScrollDirection } from 'hooks/useScrollDirection';
import React from 'react';

import * as S from './styles';

type LoggedScreenProps = {
  content: React.ReactNode;
  showSubHeader?: boolean;
  showListControls?: boolean;
  className?: string;
};

export default function LoggedScreen({
  content,
  showSubHeader = true,
  showListControls = false,
}: LoggedScreenProps) {
  const { isAtTop, scrollDirection } = useScrollDirection();
  const { isNotDesktop } = useBreakpoints();

  const showOnScrollUp =
    !isNotDesktop || isAtTop || scrollDirection === 'up';

  const renderHeader = () => <Header />;
  const renderSubHeader = () => null;

  const renderContent = () => {
    if (!showSubHeader) return content;
    return (
      <>
        <CollapsibleSection $isVisible={showOnScrollUp} $stickToTop>
          <S.ShowBelowDesktop>
            <UserDetailsBar />
          </S.ShowBelowDesktop>
          <NewCategoriesFilter showFilterAndViewControls={showListControls} />
          {showListControls && <ListControlsBar />}
        </CollapsibleSection>
        {content}
      </>
    );
  };

  const renderFooter = () => <Footer />;
  return (
    <Screen
      header={renderHeader()}
      subHeader={renderSubHeader()}
      footer={renderFooter()}
    >
      {renderContent()}
      <FeatureFlagDebugPanel />
    </Screen>
  );
}
